import styled from 'styled-components';

const GridCardFooter = styled.div`
  padding: 8px 16px;
  display: flex;
  justify-content: center;
`;

export default GridCardFooter;
